// よくある質問ページのトグル実装
const faqElements = document.querySelectorAll(".faq");

faqElements.forEach(function(target){
  target.addEventListener('click', function() {
    if(target.children[0].children[1].style.display === 'block') {
      target.children[0].children[1].style.display = 'none';
      target.children[1].children[0].src = 'https://cdn.shopify.com/s/files/1/0538/4948/9598/files/close.png?v=1616305210';
    } else {
      target.children[0].children[1].style.display = 'block';
      target.children[1].children[0].src = 'https://cdn.shopify.com/s/files/1/0538/4948/9598/files/open.png?v=1616305210';
    }
  });
});

// トップページで受け取り場所をクリックした時に、ローカルストレージに保存
const city = document.getElementById("city");
const morino = document.getElementById("morino");
const police = document.getElementById("police");
const cityBuilding = document.getElementById("city-building");

if (city) {
  city.addEventListener("click", () => {
    localStorage.setItem('receivePlace', "city");
  });
}

if (morino) {
  morino.addEventListener("click", () => {
    localStorage.setItem('receivePlace', "morino");
  });
}

if (police) {
  police.addEventListener("click", () => {
    localStorage.setItem('receivePlace', "police");
  });
}

if (cityBuilding) {
  police.addEventListener("click", () => {
    localStorage.setItem('receivePlace', "city-building");
  });
}

// プルダウンで受け取り場所を変更した時に、ローカルストレージに保存
const receivePlaceSelect = document.getElementById("receivePlaceSelect");

if (receivePlaceSelect) {
  receivePlaceSelect.addEventListener("change", (e) => {
    const url = `${window.location.protocol}//${window.location.host}/pages/${e.target.value}`
    localStorage.setItem('receivePlace', e.target.value);
    location.href = url;
  });
}

// ストアトップへ遷移されたときに、ローカルストレージに保存
window.onload = () => {
  const shopPathList = ["city", "morino", "police", "city-building"];
  const receivePlace = location.pathname.split("/")[2];
  if (shopPathList.includes(receivePlace)){
    localStorage.setItem('receivePlace', receivePlace);
  }
}

// 滑らかスクロール
$(function(){
	$('a[href^="#"]').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top - 20;
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});
});